module.exports = __webpack_public_path__ + "img/图片8.a8b7c844.png";